import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CreateKnowledgeBaseItem, DataResponse, KnowledgeBaseItemSchema } from "schema"
import { z } from "zod"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

type Response = DataResponse<z.infer<typeof KnowledgeBaseItemSchema>>

const FrontendCreateKnowledgeBaseItemSchema = CreateKnowledgeBaseItem.omit({
  content: true,
}).extend({
  content: z.union([z.string(), z.instanceof(FileList), z.null()]),
})

export function useCreateKnowledgeBaseMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof FrontendCreateKnowledgeBaseItemSchema>) => {
      const response = await axios.post<Response>(`/knowledgeBase`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [knowledgeBaseQuery().queryKey.at(0)] })
    },
  })
}
